import BackBtn from '../Buttons/BackBtn/BackBtn';
import ContinueBtn from '../Buttons/ContinueBtn/ContinueBtn';
import './CheckoutMain.css';
import { Link } from 'react-router-dom';
import InformationForm from '../Inputs/InformationForm/InformationForm';
import BillingInfoForm from '../Inputs/BillingInfoForm/BillingInfoForm';
import PaymentInfoForm from '../Inputs/PaymentInfoForm/PaymentInfoForm';
import React, { useState } from 'react';





const CheckoutMain = () => {

    const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

//   if (isChecked === false){
//     console.log('checked');
//   } else{
//     console.log('unchecked');
//   }


    return ( 
        <div className="checkoutmain">
            <div className="checkoutmainall">
                <div className="checkoutmainforms">
                        <InformationForm />
                        <div className="checkbox">
                            <input 
                            type="checkbox" 
                            name="paymentinfoform" 
                            id="paymentinfoform"
                            // value ="#paymentinfoform"
                            value=""
                            checked={isChecked}
                            onChange={handleOnChange}
                             />
                            <label htmlFor="checkbox"> &nbsp; Billing Address same as current</label>
                        </div>
                        {
                            isChecked? " ": <div>
                            <BillingInfoForm />
                            </div>
                        }

                </div>

                <div className="checkoutmainformstwo" id="paymentinfoform">
                    <PaymentInfoForm />
                </div>

            </div>

            <div className="checkoutmainbtns">
                <Link to="#cart" onClick={event =>  window.location.href='#cart'}><BackBtn /></Link>
                <Link to="#done" onClick={event =>  window.location.href='#done'}><ContinueBtn /></Link>
            </div>
        </div>
     );
}
 
export default CheckoutMain;